export default __webpack_public_path__ + "static/media/arlogo.6390b351.png";